import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pdf-merge-dialog',
  templateUrl: './pdf-merge-dialog.component.html',
  styleUrls: ['./pdf-merge-dialog.component.scss']
})
export class PdfMergeDialogComponent {
  selectedTab: number = 0; // 0 for Merge, 1 for Convert

  ourPdfs: File[] = [];
  znPdfs: File[] = [];

  constructor(
    public dialogRef: MatDialogRef<PdfMergeDialogComponent>,
    private http: HttpClient,
    private toastr: ToastrService
  ) { }

  onOurPdfsSelected(event: any) {
    if (event.target.files) {
      this.ourPdfs = Array.from(event.target.files);
    }
  }

  onZnPdfsSelected(event: any) {
    if (event.target.files) {
      this.znPdfs = Array.from(event.target.files);
    }
  }

  submit() {
    const formData = new FormData();
    let endpoint = '';

    if (this.selectedTab === 0) { // Merge
      if (this.ourPdfs.length === 0 || this.znPdfs.length === 0) {
        this.toastr.warning('Please upload both Our PDFs and ZN PDFs.');
        return;
      }
      this.ourPdfs.forEach(f => formData.append('our_pdfs', f));
      this.znPdfs.forEach(f => formData.append('zn_pdfs', f));
      endpoint = `${environment.apiBaseUrl}/vp-periodicReport/merge-pdf`;
    } else { // Convert
      if (this.znPdfs.length === 0) {
        this.toastr.warning('Please upload ZN PDFs.');
        return;
      }
      this.znPdfs.forEach(f => formData.append('zn_pdfs', f));
      endpoint = `${environment.apiBaseUrl}/vp-periodicReport/convert-pdf`;
    }

    // Since the user wants to be able to close the popup and work, we will close the dialog now
    // and pass the payload + endpoint to the parent component or a service to handle in the background.
    this.dialogRef.close({
      endpoint: endpoint,
      formData: formData
    });
  }

  close() {
    this.dialogRef.close();
  }
}
